/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Project_Type_LiveInputs */



/**
* | output |
* | --- |
* | "Live" |
*
* @param {New_Project_Type_LiveInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_project_type_live = /** @type {((inputs?: New_Project_Type_LiveInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Project_Type_LiveInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("En direct")
	if (locale === "de") return /** @type {LocalizedString} */ ("Live")
	if (locale === "it") return /** @type {LocalizedString} */ ("Vivere")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Жить")
	if (locale === "es") return /** @type {LocalizedString} */ ("Vivir")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("居住")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ライブ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("रहना")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ao vivo")
	return /** @type {LocalizedString} */ ("Live")
});